import { useState, useContext } from 'react'
import { Handle, Position, useReactFlow } from '@xyflow/react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import CheckIcon from "@mui/icons-material/Check";

function WorkflowAgentNode({ id, data }) {
    const context = useContext(WorkflowContext);

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node agent " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="node-target" position={Position.Left} />
            <SmartToyIcon />
            { data.label }
            <Handle type="source" id="tool-source" position={Position.Right} />
        </div>
    );
}

export default WorkflowAgentNode;